// trackingMixin.js
import Vue from 'vue';

Vue.mixin({
  created() {
    if (this._computedWatchers) {
      Object.keys(this._computedWatchers).forEach(key => {
        const watcher = this._computedWatchers[key];

        // Wrap the evaluate method to log when the computed property is recalculated
        const originalEvaluate = watcher.evaluate.bind(watcher);
        watcher.evaluate = function () {
          this.$compCount.total = ++this.$compCount.recalc + this.$compCount.access;
        //   console.log(
        //     `Computed prop. "${key}" recalculated in component "${this.$options.name || 'anonymous'}"${
        //       this.$options.propsData && this.$options.propsData.id ? ' / id: ' + this.$options.propsData.id : ''
        //     }`
        //   );
          originalEvaluate();
        }.bind(this);

        // Wrap the computed property's getter to log when it's accessed
        const propertyDescriptor = getPropertyDescriptor(this, key);
        if (propertyDescriptor && typeof propertyDescriptor.get === 'function') {
          const originalGetter = propertyDescriptor.get;
          const originalSetter = propertyDescriptor.set;

          const propertyDefinition = {
            get() {
                this.$compCount.total = this.$compCount.recalc + ++this.$compCount.access;
                // console.log(
                //     `Computed prop. "${key}" accessed in component "${this.$options.name || 'anonymous'}"${
                //         this.$options.propsData && this.$options.propsData.id ? ' / id: ' + this.$options.propsData.id : ''
                //     }`
                // );
                return originalGetter.call(this);
            },
            configurable: true,
          };

          // Preserve the setter if it exists
          if (typeof originalSetter === 'function') {
            propertyDefinition.set = function(value) {
              return originalSetter.call(this, value);
            };
          }

          Object.defineProperty(this, key, propertyDefinition);
        }
      });
    }

    // Helper function to get the property descriptor from the prototype chain
    function getPropertyDescriptor(obj, key) {
      let desc;
      let proto = obj;
      while (proto && !(desc = Object.getOwnPropertyDescriptor(proto, key))) {
        proto = Object.getPrototypeOf(proto);
      }
      return desc;
    }
  },
});





// // trackingMixin.js
// import Vue from 'vue';

// Vue.mixin({
//   created() {
//     // Wrap computed property watchers
//     const watchers = this._computedWatchers;
//     if (watchers) {
//       Object.keys(watchers).forEach(key => {
//         const watcher = watchers[key];
//         const originalGetter = watcher.getter;

//         watcher.getter = function () {
//           const isDirty = watcher.dirty;
//           const result = originalGetter.call(this);

//           if (isDirty) {
//             console.log(
//               `Computed prop. "${key}" recalculated in component "${this.$options.name || 'anonymous'}"${
//                 this.$options.propsData && this.$options.propsData.id ? ' / id: ' + this.$options.propsData.id : ''
//               }`
//             );
//           } else {
//             console.log(
//               `Computed prop. "${key}" accessed (cached value) in component "${this.$options.name || 'anonymous'}"${
//                 this.$options.propsData && this.$options.propsData.id ? ' / id: ' + this.$options.propsData.id : ''
//               }`
//             );
//           }

//           if (watcher.dirty) {
//             console.log(`Computed prop. recalculated and watcher.dirty still dirty`);              
//           }


//           return result;
//         }.bind(this);
//       });
//     }

//     // Wrap watchers
//     if (this.$options.watch) {
//       const watch = this.$options.watch;
//       Object.keys(watch).forEach(key => {
//         const originalWatcher = watch[key];
//         let handler;

//         if (typeof originalWatcher === 'function' || typeof originalWatcher === 'string') {
//           handler = originalWatcher;
//         } else if (typeof originalWatcher === 'object') {
//           handler = originalWatcher.handler;
//         }

//         if (handler) {
//           const wrappedHandler = function (...args) {
//             console.log(
//               `Watcher on "${key}" triggered in component "${this.$options.name || 'anonymous'}"${
//                 this.$options.propsData && this.$options.propsData.id ? ' / id: ' + this.$options.propsData.id : ''
//               }`
//             );
//             return handler.apply(this, args);
//           };

//           if (typeof originalWatcher === 'function' || typeof originalWatcher === 'string') {
//             watch[key] = wrappedHandler;
//           } else if (typeof originalWatcher === 'object') {
//             watch[key] = {
//               ...originalWatcher,
//               handler: wrappedHandler,
//             };
//           }
//         }
//       });
//     }
//   },
// });



// // trackingMixin.js
// import Vue from 'vue';

// Vue.mixin({
//   beforeCreate() {
//     // Wrap computed properties
//     if (this.$options.computed) {
//       const computed = this.$options.computed;
//       Object.keys(computed).forEach(key => {
//         const originalComputed = computed[key];
//         let getter;

//         if (typeof originalComputed === 'function') {
//           getter = originalComputed;
//         } else if (typeof originalComputed.get === 'function') {
//           getter = originalComputed.get;
//         }

//         if (getter) {
//           computed[key] = {
//             ...originalComputed,
//             get() {
//                 const watcher = this._computedWatchers[key];
//                 const isDirty = watcher.dirty; // Check if the computed property is marked as "dirty"
//                 const result = getter.call(this);
            
//                 if (isDirty) {
//                   console.log(
//                     `Computed prop. "${key}" recalc. in comp. "${this.$options.name || 'anonymous'}"${(this.$options.propsData?.id ? (' / id: ' + this.$options.propsData.id) : '')}`
//                   );
// //                  console.trace();
//                 } else {
//                   console.log(
//                     `Computed prop. "${key}" accessed (cached value) in comp. "${this.$options.name || 'anonymous'}"${(this.$options.propsData?.id ? (' / id: ' + this.$options.propsData.id) : '')}`
//                   );
//                 }
            
//                 // const dependencies = this._computedWatchers[key]?.deps || [];
//                 // dependencies.forEach((dep) => {
//                 //   try {
//                 //     const depValue = dep.value; // Attempt to fetch the value
//                 //     const depDebugInfo = dep.target?._rawValue || dep.target || depValue;
//                 //     console.log(`  Dependency ID: ${dep.id}, Value:`, depDebugInfo);
//                 //   } catch (error) {
//                 //     console.log(`  Dependency ID: ${dep.id}, could not resolve value.`);
//                 //   }
//                 // });
           

//                 return result;

//             //   console.log(`Computed prop. "${key}" recalc. in cmp "${this.$options.name || 'anonymous'}${(this.$options.propsData?.id ? (' / id: ' + this.$options.propsData.id) : '')} / Dep.: ${this._computedWatchers[key].deps.map(dep => dep.id)}"`);
//             //   return getter.call(this);
//             },
//           };
//         }
//       });
//     }

//     // Wrap watchers
//     if (this.$options.watch) {
//       const watch = this.$options.watch;
//       Object.keys(watch).forEach(key => {
//         const originalWatcher = watch[key];
//         let handler;

//         if (typeof originalWatcher === 'function' || typeof originalWatcher === 'string') {
//           handler = originalWatcher;
//         } else if (typeof originalWatcher === 'object') {
//           handler = originalWatcher.handler;
//         }

//         if (handler) {
//           const wrappedHandler = function (...args) {
//             console.log(`Watcher on "${key}" triggered in component "${this.$options.name || 'anonymous'}${(this.$options.propsData?.id ? (' / id: ' + this.$options.propsData.id) : '')}"`);
//             return handler.apply(this, args);
//           };

//           if (typeof originalWatcher === 'function' || typeof originalWatcher === 'string') {
//             watch[key] = wrappedHandler;
//           } else if (typeof originalWatcher === 'object') {
//             watch[key] = {
//               ...originalWatcher,
//               handler: wrappedHandler,
//             };
//           }
//         }
//       });
//     }
//   },
// });
